var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.menus),function(menu){return _c('menu-item',{key:menu.id,attrs:{"item":menu}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }